import { DetailAction } from '../../detail/actions/DetailAction';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { FilterState, listFilterType } from '../../../pages/content/listPage/FilterState';
import { DateUtil } from '../../utility/DateUtil';
import { getDayInfoString } from '../../utility/DateFormatter';
import { Backend } from '../../../api/Backend';
import { OptionData } from '../../../components/option/OptionData';

export class ListDayFilterActionHandler extends DetailAction {
  private filterState: FilterState;
  private replay: boolean;
  private pastAndFuture: boolean;
  constructor(backend: Backend, filterState: FilterState, focusPast = false, pastAndFuture = false) {
    super(backend);
    this.filterState = filterState;
    this.replay = focusPast;
    this.pastAndFuture = pastAndFuture;
  }

  override doAction() {
    const options = DateUtil.getFilterDates(this.replay, this.pastAndFuture).map(date => ({
      value: date,
      text: getDayInfoString(date, false, this._backend),
      selected: false,
    }));
    const filterSelected = this.filterState.stateOf(listFilterType.day);
    const targetSelected = filterSelected
      ? filterSelected.value.getTime()
      : DateUtil.toStartOfDay(new Date()).getTime();
    options.forEach(opt => {
      if (opt.value.getTime() === targetSelected) {
        opt.selected = true;
      }
    });

    this.owner?.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        centerFocusedItem: true,
        backend: this._backend,
        options: options,
        onSuccess: (val: OptionData) => {
          this.optionSelected(val);
        },
        onCancelled: this.hideOptions.bind(this),
      },
    });
  }

  optionSelected(option: OptionData) {
    this.filterState.updateState(listFilterType.day, option.text, option.value);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }
}
